<template>
<div>
    <button v-if="can_crud_jobs" v-on:click="open()" class="btn btn-primary">Change Working Week</button>

    <GenericModal ref="change_working_week" title="Change Working Week" :hideButton="true">
        <div class="work-days-input">
            <ul class="work-days-input--days">
                <li class="work-days-input--days-item">
                    <a
                        href="javascript:void(0)"
                        class="work-days-input--days-item-day"
                        v-bind:class="{
                            active: week_edit.monday,
                            bounce: bounce_anim.monday
                        }"
                        v-on:mousedown="selectWeekDay('monday')"
                        v-on:mouseup="bounce_anim.monday = false"
                        v-on:mouseleave="bounce_anim.monday = false">M</a>
                </li>
                <li class="work-days-input--days-item">
                    <a
                        href="javascript:void(0)"
                        class="work-days-input--days-item-day"
                        v-bind:class="{
                            active: week_edit.tuesday,
                            bounce: bounce_anim.tuesday
                        }"
                        v-on:mousedown="selectWeekDay('tuesday')"
                        v-on:mouseup="bounce_anim.tuesday = false"
                        v-on:mouseleave="bounce_anim.tuesday = false">T</a>
                </li>
                <li class="work-days-input--days-item">
                    <a
                        href="javascript:void(0)"
                        class="work-days-input--days-item-day"
                        v-bind:class="{
                            active: week_edit.wednesday,
                            bounce: bounce_anim.wednesday
                        }"
                        v-on:mousedown="selectWeekDay('wednesday')"
                        v-on:mouseup="bounce_anim.wednesday = false"
                        v-on:mouseleave="bounce_anim.wednesday = false">W</a>
                </li>
                <li class="work-days-input--days-item">
                    <a
                        href="javascript:void(0)"
                        class="work-days-input--days-item-day"
                        v-bind:class="{
                            active: week_edit.thursday,
                            bounce: bounce_anim.thursday
                        }"
                        v-on:mousedown="selectWeekDay('thursday')"
                        v-on:mouseup="bounce_anim.thursday = false"
                        v-on:mouseleave="bounce_anim.thursday = false">T</a>
                </li>
                <li class="work-days-input--days-item">
                    <a
                        href="javascript:void(0)"
                        class="work-days-input--days-item-day"
                        v-bind:class="{
                            active: week_edit.friday,
                            bounce: bounce_anim.friday
                        }"
                        v-on:mousedown="selectWeekDay('friday')"
                        v-on:mouseup="bounce_anim.friday = false"
                        v-on:mouseleave="bounce_anim.friday = false">F</a>
                </li>
                <li class="work-days-input--days-item">
                    <a
                        href="javascript:void(0)"
                        class="work-days-input--days-item-day"
                        v-bind:class="{
                            active: week_edit.saturday,
                            bounce: bounce_anim.saturday
                        }"
                        v-on:mousedown="selectWeekDay('saturday')"
                        v-on:mouseup="bounce_anim.saturday = false"
                        v-on:mouseleave="bounce_anim.saturday = false">S</a>
                </li>
                <li class="work-days-input--days-item">
                    <a
                        href="javascript:void(0)"
                        class="work-days-input--days-item-day"
                        v-bind:class="{
                            active: week_edit.sunday,
                            bounce: bounce_anim.sunday
                        }"
                        v-on:mousedown="selectWeekDay('sunday')"
                        v-on:mouseup="bounce_anim.sunday = false"
                        v-on:mouseleave="bounce_anim.sunday = false">S</a>
                </li>
            </ul>
            <div class="work-days-input--footer">
                <button
                    class="work-days-input--footer-button btn btn-primary"
                    v-bind:disabled="saving"
                    v-on:click="save"
                >
                    <loader class="loaders--small loaders--light" v-if="saving"></loader>
                    <span v-else>Save</span>
                </button>
            </div>
        </div>
    </GenericModal>
</div>
</template>

<script>
	import Loader from "../general_components/Loader";
    import GenericModal from '../modals/GenericModal.vue';
	export default {
		name: "WeekWorkDays",
		components: {Loader, GenericModal},
		props: {
			value: {
				type: Object,
				required: true
			},
			save_url: {
				type: String,
				required: true
			},
            can_crud_jobs: true
		},
		data() {
			return {
				week_edit: null,
				saving: false,

				bounce_anim: {
					monday: false,
					tuesday: false,
					wednesday: false,
					thursday: false,
					friday: false,
					saturday: false,
					sunday: false,
				}
			}
		},
		beforeMount() {
			this.week_edit = Object.assign({}, this.value);
		},

		methods: {
			save() {
				if (this.saving) return;

				this.saving = true;

				axios.patch(this.save_url, {
					monday: this.week_edit.monday,
					tuesday: this.week_edit.tuesday,
					wednesday: this.week_edit.wednesday,
					thursday: this.week_edit.thursday,
					friday: this.week_edit.friday,
					saturday: this.week_edit.saturday,
					sunday: this.week_edit.sunday,
				})
					.then(response => {
						this.week_edit = response.data;
						this.saving = false;
						this.$emit('input', this.week_edit);
                        this.$refs.change_working_week.close(true);

                        Vue.$toast.open({
                            message: 'Updated Working Week Days',
                            type: 'success'
                        });
					})
					.catch(error => {
                        Vue.$toast.open({
                            message: 'Something went wrong.\nPlease refresh your page and try again',
                            type: 'error'
                        });
					})
			},
			selectWeekDay(day){
				this.bounce_anim[day] = true;
				this.week_edit[day] = !this.week_edit[day];
			},
            open(){
                this.$refs.change_working_week.open();
            }
		},

		watch: {
			value() {
				this.week_edit = Object.assign({}, this.value);
			}
		}
	}
</script>
